import { isFalse } from 'my-easy-fp';
import { selector } from 'recoil';
import { getKorean, isKoreanChar } from '../../tools/calculator';
import { textCounterAtom } from '../atom/counter';

const whitespaceReg = /\s/;

export const onlyKoreanCharCountSelector = selector<number>({
  key: 'onlyKoreanCharCountSelector-dde4a13e',
  get: ({ get }) => {
    try {
      const state = get(textCounterAtom);
      const koreanChars = getKorean(state.content);
      return koreanChars.length;
    } catch (err) {
      return 0;
    }
  },
});

export const charCountState = selector<number>({
  key: 'charCountState', // unique ID (with respect to other atoms/selectors)
  get: ({ get }) => {
    const state = get(textCounterAtom);

    let counted = 0;

    for (let i = 0; i < state.content.length; i += 1) {
      const char = state.content[i];

      if (state.isSkipWhitespacee && whitespaceReg.test(char)) {
        continue;
      }

      if (char === '\n' && state.newlineCountType === 2) {
        counted += 1;
        continue;
      } else if (char === '\n' && state.newlineCountType === 3) {
        counted += 2;
        continue;
      } else if (char === '\n') {
        continue;
      }

      const isKorean = isKoreanChar(char);

      if (isKorean && state.charCountType === 4) {
        counted += 3;
      } else if (isFalse(isKorean) && state.charCountType === 4) {
        counted += 1;
      } else if (isKorean && state.charCountType === 3) {
        counted += 2;
      } else if (isFalse(isKorean) && state.charCountType === 3) {
        counted += 1;
      } else if (isKorean && state.charCountType === 2) {
        counted += 1;
      } else if (isFalse(isKorean) && state.charCountType === 2) {
        counted += 0.5;
      } else {
        counted += 1;
      }
    }

    return counted;
  },
});
